import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Search } from 'lucide-react';
import SyncStatus from '../components/SyncStatus';
const Accounts: React.FC = () => {
  const navigate = useNavigate();
  const accounts = [{
    id: 1,
    name: 'Initech',
    owner: 'John Smith',
    arr: '$75,000',
    renewalDate: 'Dec 14, 2023',
    lastSeen: 'May 9, 2023',
    status: 'Synced'
  }, {
    id: 2,
    name: 'Acme Corp',
    owner: 'Sarah Johnson',
    arr: '$120,000',
    renewalDate: 'Sep 30, 2023',
    lastSeen: 'May 8, 2023',
    status: 'Synced'
  }, {
    id: 3,
    name: 'Globex',
    owner: 'Michael Brown',
    arr: '$95,000',
    renewalDate: 'Nov 19, 2023',
    lastSeen: 'May 7, 2023',
    status: 'Synced'
  }, {
    id: 4,
    name: 'Umbrella Corp',
    owner: 'Emily Davis',
    arr: '$200,000',
    renewalDate: 'Sep 14, 2023',
    lastSeen: 'Apr 30, 2023',
    status: 'Not Synced'
  }, {
    id: 5,
    name: 'Stark Industries',
    owner: 'Robert Wilson',
    arr: '$350,000',
    renewalDate: 'Jan 9, 2024',
    lastSeen: 'May 9, 2023',
    status: 'Synced'
  }, {
    id: 6,
    name: 'Wayne Enterprises',
    owner: 'Bruce Thomas',
    arr: '$280,000',
    renewalDate: 'Aug 21, 2023',
    lastSeen: 'May 6, 2023',
    status: 'Not Synced'
  }, {
    id: 7,
    name: 'Oscorp',
    owner: 'Norman Green',
    arr: '$150,000',
    renewalDate: 'Jul 29, 2023',
    lastSeen: 'Apr 24, 2023',
    status: 'Not Synced'
  }];
  return <div className="space-y-4" data-id="element-481">
      <div className="flex justify-between items-center" data-id="element-482">
        <h1 className="text-xl font-bold text-gray-900" data-id="element-483">Accounts</h1>
        <button className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded text-sm" data-id="element-484">
          Define New Signal
        </button>
      </div>
      <div className="flex gap-4" data-id="element-485">
        <div className="relative flex-1" data-id="element-486">
          <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" size={16} data-id="element-487" />
          <input type="text" placeholder="Search accounts..." className="w-full pl-9 pr-4 py-2 border border-gray-200 rounded text-sm" data-id="element-488" />
        </div>
        <div className="relative" data-id="element-489">
          <select className="appearance-none bg-white border border-gray-200 rounded py-2 pl-3 pr-8 text-sm" data-id="element-490">
            <option data-id="element-491">Filter by Behavior Signal</option>
            <option data-id="element-492">High Report Exports</option>
            <option data-id="element-493">Frequent Admin Panel Usage</option>
            <option data-id="element-494">High Churn Risk</option>
          </select>
          <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700" data-id="element-495">
            <svg className="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" data-id="element-496">
              <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" data-id="element-497" />
            </svg>
          </div>
        </div>
      </div>
      <div className="bg-white border border-gray-200 rounded-sm overflow-hidden" data-id="element-498">
        <table className="w-full" data-id="element-499">
          <thead data-id="element-500">
            <tr className="text-left text-xs text-gray-500 border-b border-gray-200" data-id="element-501">
              <th className="px-4 py-3 font-medium" data-id="element-502">Company Name</th>
              <th className="px-4 py-3 font-medium" data-id="element-503">Owner</th>
              <th className="px-4 py-3 font-medium" data-id="element-504">ARR</th>
              <th className="px-4 py-3 font-medium" data-id="element-505">Renewal Date</th>
              <th className="px-4 py-3 font-medium" data-id="element-506">Last Seen</th>
              <th className="px-4 py-3 font-medium" data-id="element-507">HubSpot Sync</th>
            </tr>
          </thead>
          <tbody data-id="element-508">
            {accounts.map(account => <tr key={account.id} className="border-b border-gray-100 hover:bg-gray-50 cursor-pointer" onClick={() => navigate(`/accounts/${account.id}`)} data-id="element-509">
                <td className="px-4 py-3 text-sm" data-id="element-510">{account.name}</td>
                <td className="px-4 py-3 text-sm" data-id="element-511">{account.owner}</td>
                <td className="px-4 py-3 text-sm" data-id="element-512">{account.arr}</td>
                <td className="px-4 py-3 text-sm" data-id="element-513">{account.renewalDate}</td>
                <td className="px-4 py-3 text-sm" data-id="element-514">{account.lastSeen}</td>
                <td className="px-4 py-3" data-id="element-515">
                  <SyncStatus status={account.status as 'Synced' | 'Not Synced'} data-id="element-516" />
                </td>
              </tr>)}
          </tbody>
        </table>
      </div>
    </div>;
};
export default Accounts;